var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3125 31.604L11.3452 24.4579C13.0817 22.6933 15.9055 22.6266 17.7233 24.3073L31.8125 37.3332",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8334 30.4585L39.9766 9.06961C39.9766 9.06961 39.9766 2.9585 35.2501 2.9586H23.1711C21.6433 2.95848 18.0534 2.9585 16.0464 2.9585H7.75008C5.21877 2.9585 3.16675 5.01052 3.16675 7.54183V32.7502C3.16675 35.2815 5.21877 37.3335 7.75008 37.3335H35.2501C37.7815 37.3335 39.8334 35.2815 39.8334 32.7502V30.4585Z",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4792 16.7085C15.3777 16.7085 16.9167 15.1695 16.9167 13.271C16.9167 11.3725 15.3777 9.8335 13.4792 9.8335C11.5808 9.8335 10.0417 11.3725 10.0417 13.271C10.0417 15.1695 11.5808 16.7085 13.4792 16.7085Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/imageIcon.0e4f5e4f33b6647cfd9a52ffa851f9d8.svg";
export { ForwardRef as ReactComponent };